import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import Axios from "axios";

const routePrefix = "/project/";

const ProjectApi = {
	get(dossierId) {
		const serviceUrl = prependRoot(routePrefix + dossierId, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	loadEmptyInfrastructuur() {
		const serviceUrl = prependRoot(routePrefix + "infrastructuur", getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	},
	validateInfrastructuur(infrastructuur) {
		const serviceUrl = prependRoot(routePrefix + "validateInfrastructuur", getApiRoot());
		return Axios.put(serviceUrl, infrastructuur, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	save(project) {
		const serviceUrl = prependRoot(routePrefix, getApiRoot());
		return Axios.put(serviceUrl, project, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	loadInfrastructurenByDossier(dossierId) {
		const serviceUrl = prependRoot(routePrefix + "dossier/" + dossierId + "/infrastructuren/", getApiRoot());
		return Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
	},
	getInfrastructurenInDeBuurt(lengtegraad, breedtegraad) {
		const serviceUrl = prependRoot(routePrefix + lengtegraad + "/" + breedtegraad, getApiRoot());
		let returnValue = Axios.get(serviceUrl, {
			headers: {
				'accept': 'application/json'
			}
		});
		return returnValue;
	}
};

export default ProjectApi;
